import React, { useState, useEffect } from 'react';
import { gsap } from 'gsap';
import './header.scss';

const Header = () => {
    const [isScrolled, setIsScrolled] = useState(false);
    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
    const [activeSection, setActiveSection] = useState('home');

    useEffect(() => {
        const handleScroll = () => {
            setIsScrolled(window.scrollY > 50);

            const sections = ['home', 'about', 'experience', 'projects', 'skills', 'roadmap', 'contact'];
            const scrollPosition = window.scrollY + 100;

            for (const section of sections) {
                const element = document.getElementById(section);
                if (element) {
                    const { offsetTop, offsetHeight } = element;
                    if (scrollPosition >= offsetTop && scrollPosition < offsetTop + offsetHeight) {
                        setActiveSection(section);
                        break;
                    }
                }
            }
        };

        window.addEventListener('scroll', handleScroll);

        gsap.from('.header', {
            y: -100,
            opacity: 0,
            duration: 1,
            ease: 'power3.out'
        });

        gsap.from('.nav-item', {
            y: -50,
            opacity: 0,
            duration: 0.8,
            stagger: 0.1,
            ease: 'power3.out',
            delay: 0.3
        });

        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    const toggleMobileMenu = () => {
        setIsMobileMenuOpen(!isMobileMenuOpen);
    };

    const scrollToSection = (sectionId) => {
        const element = document.getElementById(sectionId);
        if (element) {
            const offsetTop = element.offsetTop - 80;
            window.scrollTo({
                top: offsetTop,
                behavior: 'smooth'
            });
        }
        setIsMobileMenuOpen(false);
    };

    return (
        <header className={`header ${isScrolled ? 'scrolled' : ''}`}>
            <div className="header-container">
                <a 
                    href="#home" 
                    className="logo"
                    onClick={(e) => {
                        e.preventDefault();
                        scrollToSection('home');
                    }}
                >
                    <div className="logo-mark">AL</div>
                    <div className="logo-text">
                        <span className="name">Anish Lawrence</span>
                        <span className="title">Senior Frontend Developer</span>
                    </div>
                </a>

                <nav className={`nav ${isMobileMenuOpen ? 'mobile-open' : ''}`}>
                    <a 
                        href="#home"
                        className={`nav-link ${activeSection === 'home' ? 'active' : ''}`}
                        onClick={(e) => {
                            e.preventDefault();
                            scrollToSection('home');
                        }}
                    >
                        Home
                    </a>
                    <a 
                        href="#about"
                        className={`nav-link ${activeSection === 'about' ? 'active' : ''}`}
                        onClick={(e) => {
                            e.preventDefault();
                            scrollToSection('about');
                        }}
                    >
                        About
                    </a>
                    <a 
                        href="#experience"
                        className={`nav-link ${activeSection === 'experience' ? 'active' : ''}`}
                        onClick={(e) => {
                            e.preventDefault();
                            scrollToSection('experience');
                        }}
                    >
                        Experience
                    </a>
                    <a 
                        href="#projects"
                        className={`nav-link ${activeSection === 'projects' ? 'active' : ''}`}
                        onClick={(e) => {
                            e.preventDefault();
                            scrollToSection('projects');
                        }}
                    >
                        Work
                    </a>
                    <a 
                        href="#skills"
                        className={`nav-link ${activeSection === 'skills' ? 'active' : ''}`}
                        onClick={(e) => {
                            e.preventDefault();
                            scrollToSection('skills');
                        }}
                    >
                        Skills
                    </a>
                    <a 
                        href="#roadmap"
                        className={`nav-link ${activeSection === 'roadmap' ? 'active' : ''}`}
                        onClick={(e) => {
                            e.preventDefault();
                            scrollToSection('roadmap');
                        }}
                    >
                        Roadmap
                    </a>
                    <a 
                        href="#contact"
                        className="nav-link contact-link"
                        onClick={(e) => {
                            e.preventDefault();
                            scrollToSection('contact');
                        }}
                    >
                        Contact
                    </a>
                </nav>

                <button 
                    className={`mobile-menu-btn ${isMobileMenuOpen ? 'open' : ''}`}
                    onClick={toggleMobileMenu}
                    aria-label="Toggle menu"
                >
                    <span></span>
                    <span></span>
                    <span></span>
                </button>
            </div>
        </header>
    );
};

export default Header;
